const state = {
    user: {
        loggedIn: false,
        data: null,
        actions: null,
        usprivacy: "1---"
    },
    saveWordPopup: {
        visible: false
    },
    error: null
};

export default state;



// WEBPACK FOOTER //
// ./src/store/Login/state.js